import {
    /** FETCH APPLICATION  */
    FETCH_TARGETINSTITUTIONDETAIL_FULFILLED,
    FETCH_TARGETINSTITUTIONDETAIL_REJECTED,
    FETCH_TARGETINSTITUTIONDETAIL_PENDING,
    RESET_TARGETINSTITUTIONDETAIL,
  } from "../../actions/application/targetInstitutionDetail";
  const initialState = {
    done: false,
    error: false,
    spinner: false
  };
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case FETCH_TARGETINSTITUTIONDETAIL_PENDING:
        return {
          done: false,
          spinner: true,
          error: false,
        };
      case FETCH_TARGETINSTITUTIONDETAIL_FULFILLED:
        return {
          ...state,
          targetInstitutionDetail: action.payload,
          done: true,
          error: false,
          spinner : false
        };
      case FETCH_TARGETINSTITUTIONDETAIL_REJECTED:
        return {
          ...state,
          error: action.payload,
          done: false,
          spinner : false
        };
      case RESET_TARGETINSTITUTIONDETAIL:
        return {
          initialState,
          done: false,
          error: false,
          spinner : false
        };
      default:
        return state;
    }
  };
  